import React from 'react'

import { XStack } from '@zet/design-system/layout'
import { H5 } from '@zet/design-system/typography'

import { GoBackButton } from '../GoBackButton'

type HeaderProps = {
  showBackIcon?: boolean
  title?: string
  headerRightButton?: React.ReactNode
}

export default function Header({
  showBackIcon,
  title,
  headerRightButton,
}: HeaderProps) {
  return (
    <XStack className="border-grays-30 w-screen items-center justify-between border-b bg-white px-3 py-3">
      <XStack style={{ width: '70%' }} className="items-center">
        {showBackIcon && (
          <GoBackButton
            className="mr-3 h-5 w-5 items-center justify-center rounded-lg bg-[#F5F7FB]"
            color="#050505"
          />
        )}
        <H5 className="text-[#0D1321]">{title}</H5>
      </XStack>
      {headerRightButton && headerRightButton}
    </XStack>
  )
}
